import { classNameMerger } from '@breetometer/utils';
import type { FC, PropsWithChildren } from 'react';

import BreadCrumbs from '../BreadCrumb';
import type { IContentWrapper } from './ContentWrapper.helpers';

const ContentWrapper: FC<PropsWithChildren<IContentWrapper>> = ({
	hideBreadcrumb = false,
	className,
	children,
	noHome,
	pageTitle,
	activeLinkUrl,
	backUrl,
	allowOverflow = false,
}) => (
	<div
		className={classNameMerger(
			'content_wrapper bg-primary-500 border-dark-navy',
			allowOverflow && 'content_wrapper--overflow-visible',
			className
		)}
	>
		{!hideBreadcrumb && (
			<BreadCrumbs
				noHome={noHome}
				pageTitle={pageTitle}
				activeLinkUrl={activeLinkUrl}
				backUrl={backUrl}
			/>
		)}
		<div className='content_wrapper_body'>{children}</div>
	</div>
);

export default ContentWrapper;
